import InputsImportBillingPage from "pages/spreadsheet/InputsImportBilling";
import { Route } from "react-router-dom";
import Spreadsheet from "./Spreadsheet";

const routes = {
  key: "INPUTS_TABLE",
  routes: ({ userScope }) => [
    <Route key={"inputTable"} path={`${userScope}/inputs`}>
      <Route
        key={"inputTable-import"}
        path={`spreadsheet`}
        element={<Spreadsheet />}
      />
      <Route
        key={"inputTable-import-billing"}
        path={`import-billing`}
        element={<InputsImportBillingPage />}
      />
    </Route>,
  ],
};
export default routes;
